import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

export const findSigners = createAsyncThunk(
  "documentSignerShow/findSigners",
  async (idDocument: string, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}documentstakeholder`, {
        params: {
          where: {
            document: idDocument,
          },
          sort: "order ASC",
        },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

